import React, { forwardRef } from 'react';
import styled from '@emotion/styled';
import Timestamp from '@polestar/component-warehouse-react/components/timestamp/Timestamp';
import Image from '@polestar/component-warehouse-react/components/image/Image';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import { CrossAxisAlignments, MainAxisAlignments, } from '@polestar/component-warehouse-react/tokens/alignments/Alignments';
import { responsiveStyles } from '@polestar/component-warehouse-react/helpers/responsiveStyle';
const VideoPlayerThumbnail = forwardRef(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
({ duration, children, ...props }, ref) => (React.createElement(Container, { ref: ref },
    React.createElement(Image, { ...props }),
    React.createElement(StyledTime, { value: duration, background: true }))));
VideoPlayerThumbnail.displayName = 'VideoPlayerThumbnail';
export default VideoPlayerThumbnail;
const Container = styled.div `
  position: relative;
  display: block;
`;
Container.displayName = `Container`;
const StyledTime = styled(Timestamp) `
  position: absolute;
  ${responsiveStyles({
    insetBlockEnd: {
        mobile: Spacings.xSmall,
        tablet: Spacings.medium,
    },
    insetInlineStart: {
        mobile: Spacings.xSmall,
        tablet: Spacings.medium,
    },
})}
`;
export const VideoPlayerThumbnailCardOverlay = forwardRef(({ value, background = true, ...props }, ref) => (React.createElement(VideoPlayerThumbnailCardOverlayContainer, { ref: ref },
    React.createElement(Timestamp, { ...props, value: value, background: background }))));
VideoPlayerThumbnailCardOverlay.displayName = 'VideoPlayerThumbnailCardOverlay';
const VideoPlayerThumbnailCardOverlayContainer = styled.div `
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: ${MainAxisAlignments.start};
  align-items: ${CrossAxisAlignments.end};
  ${responsiveStyles({
    padding: {
        mobile: Spacings.xSmall,
        tablet: Spacings.medium,
    },
})}
`;
